import React from "react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography, IconButton,
} from "@mui/material";
import useAuthStore from "../../hooks/store/auth";
import { Layout as AuthLayout } from "../../common/Layout/auth/layout";
import { useNavigate } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Page = () => {
  const router = useNavigate();

  const { loginAction, isAuth, token, logoutAction, loading } = useAuthStore();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      submit: null,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email is required"),
      password: Yup.string().max(255).required("Password is required"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        loginAction({ email: values.email, password: values.password });
        // router("/");
      } catch (err) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  React.useEffect(() => {
    if (isAuth === true) {
      router("/");
    }
  }, [isAuth, router]);

  React.useEffect(() => {
    if (isAuth && !token) {
      logoutAction();
    }
  }, [isAuth, logoutAction, token]);

  return (
    <AuthLayout>
      <Box
        sx={{
          backgroundColor: "background.paper",
          flex: "1 1 auto",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: 550,
            px: 3,
            py: "100px",
            width: "100%",
          }}
        >
          <div>
            <Stack spacing={1} sx={{ mb: 3 }}>
              <Typography variant="h4">Login</Typography>
            </Stack>

            <form noValidate onSubmit={formik.handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  error={!!(formik.touched.email && formik.errors.email)}
                  fullWidth
                  helperText={formik.touched.email && formik.errors.email}
                  label="Email Address"
                  name="email"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type="email"
                  value={formik.values.email}
                />
                <TextField
                  error={!!(formik.touched.password && formik.errors.password)}
                  fullWidth
                  helperText={formik.touched.password && formik.errors.password}
                  label="Password"
                  name="password"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.password}
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
              {/* <FormHelperText sx={{ mt: 1 }}>
                Optionally you can skip.
              </FormHelperText> */}
              {formik.errors.submit && (
                <Typography color="error" sx={{ mt: 3 }} variant="body2">
                  {formik.errors.submit}
                </Typography>
              )}

              <Button
                fullWidth
                size="large"
                sx={{ mt: 3 }}
                type="submit"
                variant="contained"
              >
                {loading ? (
                  <CircularProgress size={25} style={{ color: "#0b3b4b" }} />
                ) : (
                  "Login"
                )}
              </Button>
              {/* <Button
                fullWidth
                size="large"
                sx={{ mt: 3 }}
                onClick={handleSkip}
              >
                Skip authentication
              </Button> */}

              {/* <Typography
                color="text.secondary"
                variant="body2"
                textAlign={"center"}
                sx={{ p: 1, pb: 0 }}
              >
                Forgot password? &nbsp;
                <Button color="secondary" to="/reset-password" component={Link}>
                  Reset
                </Button>
              </Typography> */}
              {/* <Typography
                color="text.secondary"
                variant="body2"
                textAlign={"center"}
              >
                Don&apos;t have an account? &nbsp;
                <Button color="secondary" to="/register" component={Link}>
                  SignUp
                </Button>
              </Typography> */}
              {/* <Alert color="primary" severity="info" sx={{ mt: 3 }}>
              </Alert> */}
            </form>
          </div>
        </Box>
      </Box>
    </AuthLayout>
  );
};

Page.getLayout = (page) => <AuthLayout>{page}</AuthLayout>;

export default Page;
